import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_VIDEO_COMMENTS, res.data)
  })
)

export const updateStatus = async ({ commit }, { id, status }) => {
  await services.updateStatus(id, status).then(res => {
    return res
  })
}

export const destroy = async ({ commit }, id) => {
  await services.destroy(id).then(res => {
    return res
  })
}

export const updateModeration = async ({ commit }, { settingId, value }) => {
  await services.updateModeration(settingId, value).then(res => {
    return res
  })
}
